"use strict";
exports.__esModule = true;
var schema_1 = require("./schema");
exports["default"] = (function (config) {
    schema_1["default"](config);
    return schema_1["default"].errors;
});
